export function getCacheExpiryDuration() {
    return 24 * 60 * 60;
}

export function getPollingDelay() {
    return 5 * 1000; // Poll every 5 seconds for active job status
}

export function getJobListPollingDelay() {
    return 60 * 1000; // Poll every 60 seconds for job list updates
}

export function getAttemptsOnEmptyResults() {
    return 5;
}

export function getPageInterval() {
    return 7 * 24 * 60 * 60;
}

export function getRefreshInterval() {
    return 1 * 24 * 60 * 60
}

export function getMaxRetriesOnErrorConfig() {
    return 1;
}